// extracted by mini-css-extract-plugin
export var errorIcon = "_mr-1";
export var nameLogo = "_mr-0";